var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"notfound"}},[_c('div',{staticClass:"notfound"},[_vm._m(0),_c('h2',{staticClass:"mt-3"},[_vm._v("Trang không được tìm thấy")]),_c('p',[_vm._v("Trang đang được xây dựng hoặc không tồn tại trong hệ thống")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Trang chủ")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound-404"},[_c('h1',[_vm._v("404")])])
}]

export { render, staticRenderFns }